module.exports = function() {
  return new Worker(__webpack_public_path__ + "c7b4e7b0c7ae734185c0.worker.js");
};